<template>
    <div class="debug-bar">
        <div class="location-selector">
            Location: <select @change="changeLocation($event)" v-model="options.location"><option v-for="location in startlocations" :value="location.id">{{location.slug}} - {{location.id}}</option></select>
        </div>
        <div class="check">
            Webview: <input type="checkbox" v-model="options.isWebView">
        </div>
        <div class="check">
            ReturnToHome: <input type="checkbox" v-model="options.returnToHome">
        </div>
    </div>
</template>

<script>
import { nodes, servicePoints, getActiveHouses, getDirectionHouses, navigate, startDescriptions, parseNode } from '@/nodes.js'

    export default {
        name: "DebugBar",
        data: function (){
            return {
                nodes: [],
                // location: ''
            }
        },
        computed: {
            startlocations: function(){
                return this.nodes.filter(x=> x.isStartpoint == true)
            }
        },
        methods: {
          changeLocation: function (event){
              const url = new URL(window.location)
              let params = new URLSearchParams(document.location.search)
              let node = this.nodes.find(x=>x.id == event.target.value)
              url.searchParams.set('startpoint', node.slug)
              url.searchParams.set('returntohome', this.options.returnToHome)
              url.searchParams.set('webview', this.options.isWebView)
              window.location.href = url.toString();
              // console.log(params)
          }
        },
        props: ['store', 'location', 'languageStrings', 'currentLanguage', 'options'],
        created() {
            this.nodes = nodes
            // this.location = options.location
        }
    }
</script>

<style scoped lang="scss">
    .debug-bar {
        height: 40px;
        position: fixed;
        top: 0px;
        width: 100%;
        background: black;
        opacity: 0.8;
        color: white;
        z-index: 100;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 10px;

        .check {
            padding: 0 10px;
        }
    }
</style>